module.exports = __webpack_public_path__ + "img/fashion_14.3058a650.jpg";